import { entriesEndpoint } from '@/ui/core/config'
import { GuestbookClient } from '../GuestbookClient'
import { IdResponseSchema } from '@/shared/types'
import { uploadImage } from './uploadImage'

export interface CreateEntryInput {
  eventId: string
  guestName: string
  message?: string
  file?: File
}
export async function createEntry(
  this: GuestbookClient,
  input: CreateEntryInput,
): Promise<string> {
  if (input.eventId === '') {
    throw new Error('Missing eventId')
  }

  if (!input.message && !input.file) {
    throw new Error('Requires either message or photo')
  }

  const jwtToken = (await this.auth.getJWT()) ?? ''
  const images: string[] = []

  const { file, ...props } = input
  if (file) {
    if (/^image\/?!(svg|gif)/.test(file.type)) {
      throw new Error('Not supported image types')
    }

    const url = await uploadImage({
      file,
      location: 'entries',
      keyPrefix: input.eventId,
      jwtToken,
    })

    images.push(url)
  }

  const result = await fetch(entriesEndpoint, {
    method: 'POST',
    body: JSON.stringify({ ...props, images }),
    headers: {
      Authorization: jwtToken,
    },
  })

  const response = IdResponseSchema.parse(await result.json())
  return response.id
}
